<template>
  <v-container>
    <v-layout>
      <v-flex md6>

      </v-flex>
      <v-flex md6>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { TeacherRepository } from '@/repository/TeacherRepository.js'
import { firestore } from '@/repository/client/firestore.js'

export default {
  name:'TeacherMyPage',
  data(){
    return {
      teacher: this.$store.getters.teacher
    }
  },
  created: function(){
    this.repo = new TeacherRepository(firestore)
  }
}

</script>

